import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  postAPI_Create_A_Message,
  API_EmbedPage_Integration,
} from '../../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
const GreetingCode2 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode2 = `integration-${short.generate()}-eyeCatcher`;

let arr = [];
export default function AddEmbedPageIntegration({ visible, toggle, LoadIntegrations }) {
  const [property, setProperty] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Level: 'Group',
    Properties: property,
    SessionTimeoutInSeconds: 600,
    BaseUrl: 'https://www.bookmebob.com',
    HomePageRoute: '/',
    DefaultLanguage: 'en-US',
    DefaultRuleDescription: 'Default',
    layoutType: 0, arrowType: 0, arrowSize: 40, arrowColor: 'black'
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
        let lst = [];
        res.data.map((m) =>
          lst.push(m.id));
        setInputData({ ...inputData, Properties: lst });
      })
      .catch((err) => console.error(err));
  }, []);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleCheckChange = (e) => {
    let filterList = [];
    if (inputData.Properties.filter((p) => p === e.target.value).length > 0) {
      filterList = inputData.Properties.filter(f => f !== e.target.value);
    }
    else {
      filterList = inputData.Properties;
      filterList.push(property.filter((p) => p.id === e.target.value)[0].id);
    }
    setInputData({ ...inputData, Properties: filterList });
  };

  const handleSave = async () => {
    /**  When creating a response for a integration, don't need pass a property id*/
    Axios.all([
      AxiosAPI({
        method: 'post',
        url: `${API_EmbedPage_Integration}`,
        data: inputData,
      }),
    ]).then(() =>
      setTimeout(() => {
        LoadIntegrations();
      }, 300)
    );
    toggle();
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Connect Embed ServiceCodeSnippet to your website</h6>
                <Separator className="mb-3" />

                <Form>
                  <FormGroup className="text-left mb-2">
                    <Label>Enter your Website Address</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Enter your website address"
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className='my-2 text-center'><h3>Select your business name</h3> </div>
                    <div className='integration-property'>
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="checkbox"
                            id={index}
                            value={p.id}
                            label={p.name}
                            //checked={inputData.Properties.filter((f) => p.id === f).length > 0 ? true : false}
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  <Button className="text-white" color="primary" size="xs" onClick={handleSave}>
                    Get Started
                  </Button>
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
